import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { FAQItemProps } from '@zola/zola-ui/src/components/PreAuthV3/FAQItem';

export const FAQItems: FAQItemProps[] = [
  {
    answer: (
      <>
        It&apos;s a good idea to go through every room.{' '}
        <LinkV2 inline variant="tertiary" href="/registry/checklist/kitchen-essentials3">
          Start with the kitchen
        </LinkV2>
        . Add appliances, cookware, drinkware, and dinnerware. And china is always a classic
        registry gift! Now for the bedroom. Ready for new bedding? Maybe upgrade your bathroom
        towels.
        <br />
        Don&apos;t forget the humbler items as well — those useful items that will make a real
        difference to your everyday life. Think about a stylish trash can, a set of new knives, wine
        glasses for every occasion, mixing bowls, and storage solutions. Trust us!
      </>
    ),
    question: 'What should we include in our wedding registry checklist?',
  },
  {
    answer: (
      <>
        Two words: cash gifts.{' '}
        <LinkV2 inline variant="tertiary" href="/shop/honeymoon-cash-funds">
          Create cash funds
        </LinkV2>{' '}
        for anything from your honeymoon or house down payment — multiple guests can contribute so
        you can think of big-ticket items. Speaking of your honeymoon registry,{' '}
        <LinkV2
          inline
          variant="tertiary"
          href="https://www.zola.com/shop/category/luggage-and-travel"
        >
          don&apos;t forget luggage
        </LinkV2>
        !
      </>
    ),
    question: "We've got cookware, bedding, and linens. Any other must-haves?",
  },
  {
    answer: (
      <>
        Absolutely! It&apos;s a great way for your guests to share in this amazing moment. With a
        Zola registry, you&apos;ll find the brands you love, add gifts from literally anywhere, AND
        create cash funds — for your honeymoon, a house downpayment, or… anything at all.
        <br />
        Remember, you can{' '}
        <LinkV2
          inline
          variant="tertiary"
          href="/expert-advice/how-to-create-a-registry-if-you-already-live-together"
        >
          upgrade what you already have
        </LinkV2>
        . Here&apos;s a good way to get started. Take a walk around your home and notice what is
        missing or what you&apos;ve been meaning to replace. This could be a good moment to replace
        those mismatched plates or that “tempramental” coffee maker you&apos;ve had since college.
        <br />
        And if you really don&apos;t need anything new,{' '}
        <LinkV2 inline variant="tertiary" href="/shop/category/local-experiences">
          think about our experiences
        </LinkV2>
        . Get a monthly coffee or wine subscription. Join a weekly meal club. Elevate date night
        with a cooking class, foraging expedition, or boat trip.
        <br />
        There are also gift cards for travel and accommodation, home decor and renovations, pet
        care, cooking classes, fitness classes… plus{' '}
        <LinkV2 inline variant="tertiary" href="/shop/category/gift-cards">
          gift cards
        </LinkV2>{' '}
        for all your favorite big box stores and online retailers.
      </>
    ),
    question: "We've been living together for a while. Do we need a registry?",
  },
  {
    answer: (
      <>
        Whether you&apos;re in Austin or Atlanta, Los Angeles or Las Vegas, we&apos;ve got great{' '}
        <LinkV2 inline variant="tertiary" href="/shop/category/local-experiences">
          experiences you can add to your registry
        </LinkV2>{' '}
        to keep the celebrations going long after your wedding day. A few of our favorites include
        whale watching in Boston, a paddleboard yoga class in Miami, a behind-the-scenes Broadway
        tour in New York, and the Chicago craft brewery tasting in a barrel bus. And if you&apos;re
        honeymooning in Hawaii, try a helicopter tour or go nighttime snorkeling with manta rays.
      </>
    ),
    question: 'Do you offer experiences in our city?',
  },
  {
    answer: (
      <>
        <LinkV2
          inline
          variant="tertiary"
          href="https://www.zola.com/expert-advice/essentials-to-put-on-your-registry"
        >
          Oh yes.
        </LinkV2>{' '}
        Melissa from Team-Z, our expert wedding advisors, has lots of great thoughts here. “I
        recommend registering for 12 sets of plates/flatware. This may seem excessive, but one day
        your tabletop items will be discontinued and you&apos;ll be glad to have some backup if some
        break or go missing.” She also recommends registering for at least two new sets of sheets
        and bath linens.
      </>
    ),
    question: 'Any pro tips for what to register for?',
  },
  {
    question: 'Any advice for cash funds?',
    answer: (
      <>
        Be specific. Instead of creating a general cash fund,{' '}
        <LinkV2
          inline
          variant="tertiary"
          href="https://www.zola.com/expert-advice/wedding-registry-tips"
        >
          create smaller funds for particular items
        </LinkV2>
        . For example, instead of a honeymoon fund, why not set up a fund for your flights, for a
        romantic dinner, and scuba diving lessons. It helps guests really feel connected to your
        plans (and you can tell them all about it when you write them a thank you note!)
      </>
    ),
  },
  {
    question: 'When should we start our registry?',
    answer: (
      <>
        <LinkV2 inline variant="tertiary" href="/registry/overview">
          It&apos;s never too early
        </LinkV2>
        ! It&apos;s always worth having a few items on your registry once you get engaged as your
        friends and family might just want to treat you when they hear your big news! Then, keep
        topping up your registry, especially just before your wedding shower and your wedding
        itself.
      </>
    ),
  },
  {
    question: 'What are some registry mistakes to avoid?',
    answer: (
      <>
        One of the most common mistakes we see is when couples simply{' '}
        <LinkV2
          inline
          variant="tertiary"
          href="/expert-advice/how-many-gifts-to-register-for-your-wedding-the-ultimate-guide"
        >
          don&apos;t have enough gifts
        </LinkV2>{' '}
        on their wedding registry. Guests love options, so make sure to include plenty of options
        for them to choose from!
        <br />
        Also, remember to include gift options in a wide range of prices. Luckily Zola has you
        covered, from affordable options to the bigger items. You can always add and edit gifts
        later, as well as exchange them or convert to credit if you change your mind.
      </>
    ),
  },
  {
    question: 'So, what makes Zola one of the best places to register for wedding gifts?',
    answer: (
      <>
        One of the perks of being a universal registry is that you can add gifts from anywhere, from
        big box stores to home decor from local artisans. And we&apos;ve got gifts for every price
        point. Honestly,{' '}
        <LinkV2 inline variant="tertiary" href="/wedding-registry/benefits">
          creating your registry
        </LinkV2>{' '}
        might be the most fun part of the wedding planning process.
      </>
    ),
  },
  {
    question: "We're an outdoorsy couple. What should we register for?",
    answer: (
      <>
        This is a great moment to{' '}
        <LinkV2 inline variant="tertiary" href="/shop/collection/fun-adventure">
          upgrade your camping and hiking equipment
        </LinkV2>
        . Think tents, chairs, a camping stove, flasks, and coolers. You&apos;ll even find outdoor
        games and activities and portable speakers if you want to have fun in the great outdoors.
      </>
    ),
  },
  {
    question: "We're foodies. Help us create our registry!",
    answer: (
      <>
        There are{' '}
        <LinkV2 inline variant="tertiary" href="/shop/collection/top-kitchen-essentials">
          some obvious things
        </LinkV2>{' '}
        here you&apos;ve probably thought of — the Dutch Oven, the stand mixer, the flatware. But
        one of the most popular gifts recently has been the outdoor pizza oven, capable of making
        authentic, delicious pizza in just 60 seconds. It&apos;s great for date night or hosting a
        post-wedding get-together. Pair that with a gas or charcoal grill and you&apos;ll be the
        envy of your neighbors.
        <br />
        For another romantic foodie gift, try a picnic basket. We love the classic wicker baskets
        that have everything you need for an impromptu al fresco feast.
        <br />
        Then there are our foodie experiences. There are at home baking classes, in person cooking
        classes, pizza tours, and gift cards for a special meal for two.
        <br />
      </>
    ),
  },
  {
    question: 'As a couple of amateur mixologists, how can we make our dream bar?',
    answer: (
      <>
        Start with a{' '}
        <LinkV2 inline variant="tertiary" href="/shop/collection/build-your-bar">
          stylish bar cart
        </LinkV2>
        . They come in all sizes, price points, and styles, from Art Deco to industrial chic. Then
        move onto the basics — a cocktail shaker and set of bar tools, like measuring glasses,
        bottle openers, and jiggers. Now, onto the glasses. Now&apos;s the perfect moment to get the
        right items for the right drinks, whether you want to serve Martinis or Margaritas the way
        bartenders intend or you want to decant wine and whiskey.
        <br />
        And if you&apos;re really serious about your home bar, we&apos;ve got you covered with
        top-quality gadgets like wine preservations systems and purifiers and carafes that aerate
        and chill.
      </>
    ),
  },
  {
    question: 'Can we register for gifts for our pets as well?',
    answer: (
      <>
        Yes! Some of our{' '}
        <LinkV2 inline variant="tertiary" href="/shop/category/pet">
          most popular gifts are for our furry friends
        </LinkV2>
        . There are luxury pet beds (no guarantees they won&apos;t just sleep on yours though), the
        most stylish litter boxes you&apos;ve ever seen, and all the treats and toys they could
        want. Plus,{' '}
        <LinkV2 inline variant="tertiary" href="/shop/category/pet-services">
          gift cards
        </LinkV2>{' '}
        to big name pet stores.
      </>
    ),
  },
  {
    question: 'What are some gifts guests love to give?',
    answer: (
      <>
        Guests just want to be able to share in this wonderful moment with you but any gift that
        lets them know they&apos;re setting you up for the next chapter of your lives together is
        perfect. That&apos;s why{' '}
        <LinkV2 inline variant="tertiary" href="/shop/collection/guests-favorites">
          gifts for the home are always so popular
        </LinkV2>
        , along with gifts they know will stand the test of time (because when else will they get
        the chance to buy a piece of beautiful crystal or high-end kitchenware?). Luggage is another
        winner — there&apos;s something symbolic about the start of a new journey. But most
        important of all are gifts that celebrate who you are as a couple — your interests, your
        ambitions, and what matters most to you.
      </>
    ),
  },
  {
    question: 'How do we make our registry extra personalized?',
    answer: (
      <>
        A great gift (and totally unique to the two of you) is a{' '}
        <LinkV2 inline variant="tertiary" href="/wedding-albums/shop">
          wedding album
        </LinkV2>
        . A guest can buy it for you and then you create it yourself once you&apos;ve got your
        beautiful wedding photos. Our free album wizard can help you create an album as personal as
        the memories inside, along with all our customization options (like size, materials, number
        of pages, etc). It&apos;s also a great gift if you&apos;re looking for something special to
        give your wedding party or in-laws to say thanks for all their help.
        <br />
        Another great way to make those gifts extra unique is to{' '}
        <LinkV2 inline variant="tertiary" href="/shop/collection/monogramming-shop">
          think about monogramming
        </LinkV2>
        . Add your initials to your luggage to make your honeymoon extra special or commemorate your
        wedding day with engraved silverware or barware.
      </>
    ),
  },
];
